export default __webpack_public_path__ + "static/media/regulation-off.8fee5363.png";